import { ScrollArea } from '@ais-ui/ui-core';
import React, { useEffect, useRef, useState } from 'react';
import { FormattingForm } from './FormattingForm';
import { UnitsForm } from './UnitsForm';
import { LayoutForm } from './LayoutForm';
import { RemoteControlForm } from './RemoteControlForm';
import { MapScaleForm } from './MapScaleForm';
import { ZoomButtonsForm } from './ZoomButtonsForm';

export function GeneralForm() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [calculatedHeight, setCalculatedHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const viewportHeight = window.innerHeight;
      const containerTop =
        containerRef.current?.getBoundingClientRect().top || 0;
      const safetyMargin = 90; // Adjust this margin as needed
      const height = viewportHeight - containerTop - safetyMargin; // Subtracting an additional margin
      setCalculatedHeight(height);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);

    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div ref={containerRef} className="h-full">
      <ScrollArea style={{ height: `${calculatedHeight}px` }} className="pr-4">
        <div className="flex flex-col space-y-12">
          <FormattingForm></FormattingForm>
          <UnitsForm></UnitsForm>
          <LayoutForm></LayoutForm>
          <RemoteControlForm></RemoteControlForm>
          <MapScaleForm></MapScaleForm>
          <ZoomButtonsForm></ZoomButtonsForm>
        </div>
      </ScrollArea>
    </div>
  );
}
